import React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';

export const QuoteEdit = () => (
  <Edit title="Edit quote" actions={false} redirect="list">
    <SimpleForm>
      <TextInput source="quote_text" label="Quote Text" required multiline rows={4} />
      <TextInput source="author_name" label="Author" required />
    </SimpleForm>
  </Edit>
);

